import React, { useEffect, useState, useRef } from 'react';
import loaderGif from '../../../images/loader.gif';
import './AiAnalysis.css';
import PropTypes from 'prop-types';

const STATUS_COLORS = {
  RESOLVED: { background: '#2ecc40', color: '#fff' },
  OVERDUE: { background: '#ff3030', color: '#fff' },
  PENDING: { background: '#FF6B00', color: '#fff' },
};
const TYPE_COLORS = {
  CRITICAL: { background: '#ff3030', color: '#fff' },
  MINOR: { background: '#ff9800', color: '#fff' },
};

const AiAnalysis = ({ reportData, vehicleName, onBack }) => {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => setLoading(false), 3000);
    return () => clearTimeout(timer);
  }, [reportData]);

  useEffect(() => {
    // Smooth scroll to top when modal opens
    if (containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [reportData]);


  return (
    <div className="ai-analysis-container" ref={containerRef}>
      <div className="ai-analysis-header-row">
        <button
          className="ai-analysis-back-btn"
          onClick={onBack}
          aria-label="Back"
        >
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="14" cy="14" r="14" fill="#18191b" />
            <path d="M16.5 19L11.5 14L16.5 9" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>

        </button>
        <span className="ai-analysis-title">AI Analysis &nbsp; - &nbsp; {vehicleName}</span>
      </div>
      {loading ? (
        <div className="ai-analysis-loader-wrapper">
          <h3 className="ai-analysis-loader-title">Running Analysis</h3>
          <img src={loaderGif} alt="Loading..." className="ai-analysis-loader" />
        </div>
      ) : (
        <div className="ai-analysis-table-wrapper">
          <table className="ai-analysis-table">
            <thead>
              <tr>
                <th>ISSUE</th>
                <th>ISSUE TYPE</th>
                <th>DESCRIPTION</th>
                <th>PREDICTED DATE</th>
                <th>ACTION</th>
                <th>REPORTED</th>
                <th>MAINTENANCE HOURS</th>
                <th>RESOLVED ON</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {(reportData || []).map((issue, idx) => (
                <tr key={idx}>
                  <td>{issue.issue}</td>
                  <td>
                    <span className="ai-badge" style={TYPE_COLORS[issue.type] || {}}>
                      {issue.type}
                    </span>
                  </td>
                  <td>{issue.description}</td>
                  <td>{issue.predicted_date ? new Date(issue.predicted_date).toLocaleDateString('en-GB') : '-'}</td>
                  <td>{issue.action}</td>
                  <td>{issue.reported_date ? new Date(issue.reported_date).toLocaleDateString('en-GB') : '-'}</td>
                  <td>{issue.maintenance_hours}</td>
                  <td>{issue.resolved_on ? new Date(issue.resolved_on).toLocaleDateString('en-GB') : '-'}</td>
                  <td>
                    <span className="ai-badge" style={STATUS_COLORS[issue.status] || {}}>
                      {issue.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

AiAnalysis.propTypes = {
  reportData: PropTypes.array,
  vehicleName: PropTypes.string,
  onBack: PropTypes.func.isRequired,
};

export default AiAnalysis;
